import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { all_routes } from "../Router/all_routes";

const api = axios.create({
  baseURL: "https://tmis.co.za/TMIS_POS_FE/Portal_Api/api",
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 🔐 Add interceptor to inject token on EVERY request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('pos_access_token');

    if (token) {
      if (!config.headers) {
        config.headers = {};
      }
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 🔥 GLOBAL RESPONSE INTERCEPTOR → Catch expired/invalid tokens
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response) {
      const status = error.response.status;
      const msg =
        error.response.data?.error_description ||
        error.response.data?.Messages?.[0] ||
        error.response.data?.Errors?.[0] ||
        "";

      const text = String(msg).toLowerCase();
      console.log(text);

      // ⛔ Token expired or invalid → Force logout + redirect
      if (status === 401) {
        // backend is giving you empty msg, so treat ANY 401 as expired if you want:
        if (!text || text.includes("expired") || text.includes("invalid_token")) {
          localStorage.clear();
          sessionStorage.clear();
          const navigate = useNavigate();
                    navigate(all_routes.signin);
          return;
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
